import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addBulletin } from '../api/v1/requests/bulletins';

export const useAddBulletin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addBulletin,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['bulletins'],
      });
    },
  });
};
